import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { updateUiAction } from 'actions/uiActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Panel from 'components/Panel'

const mapStateToProps = ({ ui }, { uiKey }) => {
  return { active: ui[uiKey] }
}

const TutorialVideo = ({ videoUrl, classes }) => (
  <div className={classes.videoWrapper}>
    <iframe
      src={videoUrl}
      frameBorder='0'
      allowFullScreen
      width='100%'
      height='250px'
    />
    <div className={classes.guideWrapper}>
      <a href='https://ipvm.com/reports/calculator-guide' target='_blank'>
        <FontAwesomeIcon icon='book' className={classes.guideIcon} />Designer / Calculator User Manual
      </a>
    </div>
  </div>
)

const VideoPanel = ({ active, uiKey, videoUrl, title, updateUiAction, classes }) => (
  <Panel
    active={active}
    component={<TutorialVideo videoUrl={videoUrl} classes={classes} />}
    title={title ||  'Tutorial'}
    updateUiAction={updateUiAction}
    uiKey={uiKey}
  />
)

export default connect(mapStateToProps, { updateUiAction })(injectSheet(style)(VideoPanel))



// WEBPACK FOOTER //
// ./src/components/VideoPanel/index.js